import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import SpeedIcon from '@mui/icons-material/Speed';
import { useColorScheme } from '@mui/material';

const items = [
  {
    icon: <SentimentVerySatisfiedIcon sx={{ fontSize: 40 }} />,
    title: '98%',
    description: 'de satisfação dos clientes com o atendimento feito pela inteligência artificial',
  },
  {
    icon: <AccessTimeIcon sx={{ fontSize: 40 }} />,
    title: '24/7',
    description: 'disponibilidade para atender seus clientes, sem interrupções',
  },
  {
    icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
    title: '+800%',
    description: 'de aumento médio no número de atendimentos realizados',
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40 }} />,
    title: '90%',
    description: 'de redução no tempo de resposta aos clientes',
  },
];

export default function Highlights() {
  // const { mode } = useColorScheme();
  
  return (
    <Box
      sx={(theme) => ({
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        bgcolor: theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
        // color: theme.palette.mode === 'light' ? 'common.white' : 'text.primary',
      })}
    >
      <Container>
        <Grid
          container
          spacing={{ xs: 2, sm: 8 }}
          columns={{ xs: 2, sm: 4 }}
        >
          {items.map(({ icon, title, description }, index) => (
            <Grid
              key={index}
              size={1}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Box
                sx={(theme) => ({
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 64,
                  height: 64,
                  borderRadius: '50%',
                  backgroundColor: 'primary.main',
                  color: 'primary.contrastText',
                  marginBottom: 2,
                })}
              >
                {icon}
              </Box>
              <Typography 
                variant="h4" 
                component="div" 
                gutterBottom
                sx={(theme) => ({
                  color: theme.palette.mode === 'light' ? 'common.white' : 'grey.800',
                })}
              >
                {title}
              </Typography>
              <Typography 
                variant="body2" 
                sx={(theme) => ({
                  color: theme.palette.mode === 'light' ? 'grey.300' : 'grey.800',
                })}
              >
                {description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}